import { isAdmin } from "../utils/functions";

const withAdmin = (Component) => (props) => {
    if (isAdmin()) return <Component {...props} />;
    return  <span className="d-flex justify-content-center align-items-center h-100 text-danger ">Not Authorized</span>;
  }
  export default withAdmin;


